import React from 'react';

import styled from 'styled-components';

import { getCityStateZipTestId } from './testIdUtils';

const Title = styled.div`
  font-family: var(--font-regular);
  font-size: 14px;
`;

const Subtitle = styled.div`
  color: var(--text-secondary);
  font-size: 12px;
`;

type Props = { address: string; dataTestId?: string };

const CMASummaryTableDataAddress = ({ address, dataTestId }: Props) => {
  const parts = address?.split(',');
  let street, cityStateZip;

  if (parts?.length) {
    street = parts[0].trim();
    cityStateZip = parts.slice(1).join(',').replace(', USA', '').trim();
  }

  return (
    <div data-test-id={dataTestId}>
      <Title>{street}</Title>
      <Subtitle data-test-id={getCityStateZipTestId(dataTestId)}>{cityStateZip}</Subtitle>
    </div>
  );
};

export default CMASummaryTableDataAddress;
